export default __webpack_public_path__ + "static/media/Icon.6f7c8130.svg";